import styled from 'styled-components';
import { OfferTemplate } from './OfferTemplate';
import { rem } from 'polished';

export const OfferStyled = styled(OfferTemplate)`
    .offer {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        max-width: ${rem(700)};
        width: 100%;
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        position: relative;
        line-height: ${rem('24px')};

        .info-icon-container {
            margin-left: 1rem;
            display: flex;
            align-items: center;
            background: none;
            border: none;
            padding: 0;
        }

        svg {
            cursor: pointer;
        }

        & > div:first-child {
            display: block;
            padding-right: ${rem(5)};

            &::first-letter {
                text-transform: capitalize;
            }
        }

        .show {
            display: block;
        }

        .icon {
            position: relative;
            top: ${rem(2)};
        }
    }
`;
